import React from 'react';

export function Note({ children }: { children: React.ReactNode }) {
  return (
    <div className="rounded-lg border border-gray-200 dark:border-gray-700 px-4 py-3 bg-gray-50 dark:bg-gray-800/50 text-gray-800 dark:text-gray-100">
      {children}
    </div>
  )
}
